// extracted by mini-css-extract-plugin
export default {"newIraUser__buttons":"IraUserNew_newIraUser__buttons__2o2jA"};